/////////////////////////////////////////
// IMPORT
/////////////////////////////////////////
import { centerObject } from '../tools/WorksSpace'
/**
 * Insctance of BackGround
 * @class BackGround
 */
class BackGround {
  /**
   * Creates an instance of BackGround.
   * @param {canvas} canvas fabric js canvas
   * @param {string} type le type de background, par default image transparent (style photoshop) mais on peut lui passer une couleur hexa
   */
  constructor(canvas, type = 'image') {
    this.canvas = canvas
    this.background = null
    this.size = null
    this.visible = true
    this.type = type
  }
  /////////////////////////////////////////
  // METHODS
  /////////////////////////////////////////
  /**
   * assigne ou reassigne le size du background charge ensuite l'image de fond
   *
   * @param {any} size
   * @memberof BackGround
   */
  draw(size) {
    this.size = size
    if (this.type === 'image') {
      this.__loadImage('data:image/gif;base64,R0lGODlhCgAKAIAAAOLi4v///yH5BAAHAP8ALAAAAAAKAAoAAAIRhB2ZhxoM3GMSykqd1VltzxQAOw==')
    } else {
      this.__createBackground()
    }
  }
  /**
   * centre le background au milieu du canvas
   *
   * @memberof BackGround
   */
  center() {
    if (this.background) {
      centerObject(this.canvas, this.background)
    }
  }
  /**
   * Charge l'image du background
   *
   * @param {any} data
   * @private
   * @memberof BackGround
   */
  __loadImage(data) {
    const bg = new Image()
    bg.addEventListener('load', this.__createBackground.bind(this, bg))
    bg.src = data
  }

  /**
   * appelé une fois l'image du background chargé. Crée l'image du background et l'applique au canvas
   *
   * @param {any} source
   * @private
   * @memberof BackGround
   */
  __createBackground(source) {
    if (this.background !== null) {
      this.canvas.remove(this.background)
    }
    if (this.type === 'image') {
      this.background = new fabric.Rect({
        fill: new fabric.Pattern({
          source,
          repeat: 'repeat'
        }),
        top: this.size.y,
        selectable: false,
        originX: 'center',
        originY: 'center',
        evented: false,
        excludeFromExport: true
      })
    } else {
      this.background = new fabric.Rect({
        fill: this.type,
        selectable: false,
        evented: false,
        evented: false
      })
    }

    this.canvas.insertAt(this.background, 0)
    this.background.set({
      width: this.size.width,
      height: this.size.height,
      visible: this.visible
    })
    this.center()
    this.background.moveTo(0)
    this.canvas.renderAll()
  }

  /**
   * Affiche le background
   *
   * @memberof BackGround
   */
  show() {
    this.visible = true
    this.background.set('visible', this.visible)

    this.canvas.renderAll()
  }

  /**
   * Masque le background
   *
   * @memberof BackGround
   */
  hide() {
    this.visible = false
    this.background.set('visible', this.visible)
    this.canvas.renderAll()
  }
  /////////////////////////////////////////
  // GETTERS / SETTERS
  /////////////////////////////////////////
}
export default BackGround



// WEBPACK FOOTER //
// ./src/model/pixel/elements/BackGround.js